import { render, staticRenderFns } from "./NoteIcon.vue?vue&type=template&id=416991bf&scoped=true"
import script from "./NoteIcon.vue?vue&type=script&lang=js"
export * from "./NoteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416991bf",
  null
  
)

export default component.exports